export default {
    code: 'en',
    submit: 'Submit',
    ok: 'Confirm',
    coopSuccess: 'Submit successfully, our business member will contact you later!',
    coop: 'Business Cooperation',
    friendLink: 'Friendship Links',
    companyAddress: 'ZBHA Group Co., Ltd.',
    wechatService: 'Official WeChat',
    china: 'National',
    oversea: 'Overseas',
    coopBusiness: 'Cooperative Business',
    coopCompany: 'Company Name',
    coopCity: 'City',
    coopName: 'Name',
    coopPhone: 'Phone Number',
    coopEmail: 'E-mail',
    inputBusiness: 'Please choose a cooperative business',
    inputCompany: 'Please fill in your company name',
    inputBirthday: 'Please fill in your city',
    inputName: 'Please fill in your name',
    inputPhone: 'Please fill in your phone number',
    realPhone: 'Phone number Input Error',
    inputEmail: 'Please fill in your e-mail',
    about: 'About us',
    spread: 'More',
    addressTitle: 'Headquarter Address',
    recruitPost: 'Job Title',
    recruitAddress: 'Working Place',
    recruitDegree: 'Educational Requirements',
    recruitExp: 'Working Years',
    recruitSalary: 'Salary Range',
    recruitDuty: 'Job Responsibilities',
    recruitContent: 'Requirements',
    toDetail: 'See Details',
    cateAll: 'All Categories',
    address: 'Adderss',
    fax: 'Fax',
    phone: 'Switchboard',
    postCode: 'Zip code',
    website: 'Website',
    jobList: 'Job List',
    recruit: 'Talent Recruitment',
    hrMail: 'HR mailbox',
    business: 'Major Business',
    train: 'Safe Train',
    press: 'Press',
    prevPage: 'Previous',
    nextPage: 'Next',
    pageGo: 'Jump',
    pubAt: 'Date of publication',
    service: 'Service Center',
    productBuy: 'Product Purchase',
    productPay: 'Order Payment',
    buySubmit: 'Submit Order',
    buyConfirm: 'Order Confirmation',
    customPrice: 'Custom Price',
    buyCountry: 'Country of travel',
    inputBuyCountry: 'Country of travel fields, not filled in!',
    buyLastname: 'Family Name',
    inputBuyLastname: 'Family Name fields, not filled in!',
    buyFirstname: 'Given Name',
    inputBuyFirstname: 'Given Name fields, not filled in!',
    buyCellphone: 'Cellphone Number',
    inputBuyCellphone: 'Cellphone Number fields, not filled in!',
    realBuyCellphone: 'The format of the Cellphone Number is incorrect. Please enter "number"!',
    inputCountryCode: 'Country Code fields, not filled in!',
    realCountryCode: 'The format of the country number of the mobile phone is incorrect. Please enter "+number"!',
    buyIdentity: 'ID Number',
    inputBuyIdentity: 'ID Number fields, not filled in!',
    realBuyIdentity: 'ID format error!',
    buyPassport: 'Passport Number',
    inputBuyPassport: 'Passport Number fields, not filled in!',
    realBuyPassport: 'Please enter number & letter!',
    choosePay: 'Please choose the payment channel!',
    tips: 'Tips',
    payFail: 'Pay failed, please contact customer service processing 400 821 0904',
    orderFail: 'Order submission failed, please contact customer service processing 400 821 0904',
    wechatPay: 'WeChat',
    alipay: 'Alipay',
    payConfirm: 'Confirm Payment',
    scan1: 'There is ',
    scan2: 'seconds left before the QR code expires. After the expiration date, please refresh the page to get the QR code again.',
    scan3: 'The QR code has expired and the page is',
    refresh: 'refreshed',
    scan4: 'to reacquire the QR code.',
    wechatScan1: 'Please use WeChat to scan ',
    wechatScan2: 'the QR code to pay.',
    paySuccess: 'The order has been submitted and the customer service will contact you later! You can also download our APP to learn real-time information!',
    buySuccess: 'The order has been submitted and the customer service will contact you later! You can also download our APP to learn real-time information!',
    app: 'APP',
};
